import React from 'react';
import PropTypes from 'prop-types';
import Helmet from 'react-helmet';
import { ThemeProvider } from 'styled-components';
import Header from '../../components/Header/Header';
import Footer from '../../components/Footer/Footer';
import THEME from '../constants/themes.constants';
import SideNav from './SideNav/SideNav';
import GlobalStyle from '../normalize';
import { FlexContainer } from '../styled/layout.styled';
import Protected from './reusable/Protected';

const Layout = ({
  children, backGround, transparent, sideNav = false, allowedRoutes,
}) => (
  <>
    <Helmet
      bodyAttributes={{
        style: `background:${backGround} `,
      }}
    />
    <Header key="header" classes={transparent ? ['transparent'] : []} />
    <ThemeProvider theme={THEME}>
      <GlobalStyle />
      {sideNav ? (
        <Protected>
          <FlexContainer position="relative" mobileFlexDirection="column">
            <FlexContainer flexDirection="column" padding="24px 0 100px 24px" mobilePadding="0" tabletPadding="0">
              <SideNav />
            </FlexContainer>
            {children}
          </FlexContainer>
        </Protected>
      ) : (
        <> {allowedRoutes ? <> {children} </> : <Protected>{children}</Protected>}</>
      )}
    </ThemeProvider>
    <Footer />
  </>
);

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  backGround: PropTypes.string,
  transparent: PropTypes.bool,
  sideNav: PropTypes.bool,
  allowedRoutes: PropTypes.bool,
};

Layout.defaultProps = {
  backGround: '#12033d',
  transparent: false,
  sideNav: false,
  allowedRoutes: false,
};

export default Layout;
